import request from '@/utils/request'

export const listPermissions = () =>
  request({
    url: '/permission/list',
    method: 'get'
  })

export const listRoles = () =>
  request({
    url: '/permission/roles',
    method: 'get'
  })

export const createRole = (data: { code: string; name: string; remark?: string }) =>
  request({
    url: '/permission/roles',
    method: 'post',
    data
  })

export const updateRole = (data: {
  id: number
  name?: string
  remark?: string
  code?: string
}) =>
  request({
    url: '/permission/roles',
    method: 'put',
    data
  })

export const deleteRole = (id: number) =>
  request({
    url: `/permission/roles/${id}`,
    method: 'delete'
  })

export const getRolePermissions = (role: number) =>
  request({
    url: `/permission/role/${role}`,
    method: 'get'
  })

export const updateRolePermissions = (role: number, permissionIds: number[]) =>
  request({
    url: `/permission/role/${role}`,
    method: 'put',
    data: { permissionIds }
  })

export const getMyPermissions = () =>
  request({
    url: '/employee/permissions',
    method: 'get'
  })
